import { call, methodTypes } from '../utilities/http';
import {
    LOADING,
    COMPLETE,
    BACKGROUND_CHECK_GET_OK,
    BACKGROUND_CHECK_CREATE_OK,
    BACKGROUND_CHECKS_GET_OK,
    BACKGROUND_CHECK_DELETE_OK,
    BACKGROUND_CHECK_UPDATE_OK,
    BACKGROUND_CHECK_LAUNCH_OK,
    SAVING
} from './types';
import { sortByDate } from '../utilities/time';

const defaultState = {
    list: [],
    current: {}
};

export default function(state = defaultState, action) {
    const { type, data } = action;

    switch (type) {
        case BACKGROUND_CHECKS_GET_OK:
            const current = sortByDate(data, 'updated_at', false)[0];
            return {
                list: [...state.list, ...data.map(backgrounCheck => ({ [backgrounCheck.id]: backgrounCheck }))],
                current
            };

        case BACKGROUND_CHECK_GET_OK:
            return {
                list: [...state.list, ...{ [data.id]: data }],
                current: data
            };

        case BACKGROUND_CHECK_UPDATE_OK:
        case BACKGROUND_CHECK_CREATE_OK:
            return {
                ...state,
                current: { ...state.current, ...data }
            };

        case BACKGROUND_CHECK_LAUNCH_OK:
            return {
                ...state,
                current: { ...state.current, ...data }
            };

        case BACKGROUND_CHECK_DELETE_OK:
            return {
                list: state.list.filter(backgrounCheck => backgrounCheck.id !== data.id),
                current: {}
            };

        default:
            return state;
    }
}

export function getUserBackgroundChecks(userId, onSuccess = response => null, onError = response => null) {
    return async function(dispatch) {
        dispatch({ type: LOADING });
        call({ path: `/user/${userId}/background_checks` })
            .then(response => {
                dispatch({ type: COMPLETE });
                dispatch({ type: BACKGROUND_CHECKS_GET_OK, data: response });
                onSuccess(response);
            })
            .catch(error => {
                onError(error);
                dispatch({ type: COMPLETE });
            });
    };
}

export function saveUserBackgroundCheck(userId, jobId, data, onSuccess = response => null, onError = response => null) {
    return async function(dispatch) {
        dispatch({ type: SAVING });
        call({ path: '/background_check', method: methodTypes.POST, body: { user_id: userId, job_id: jobId, ...data } })
            .then(response => {
                dispatch({ type: COMPLETE });
                dispatch({ type: BACKGROUND_CHECK_CREATE_OK, data: response });
                onSuccess(response);
            })
            .catch(error => {
                onError(error);
                dispatch({ type: COMPLETE });
            });
    };
}

export function getBackgroundCheck(id, onSuccess = response => null, onError = response => null) {
    return async function(dispatch) {
        dispatch({ type: LOADING });
        call({ path: `/background_check/${id}` })
            .then(response => {
                dispatch({ type: COMPLETE });
                dispatch({ type: BACKGROUND_CHECK_GET_OK, data: response });
                onSuccess(response);
            })
            .catch(error => {
                onError(error);
                dispatch({ type: COMPLETE });
            });
    };
}

export function updateBackgroundCheck(id, data, onSuccess = response => null, onError = response => null) {
    return async function(dispatch) {
        dispatch({ type: SAVING });
        call({ path: `/background_check/${id}`, method: methodTypes.PUT, body: data })
            .then(response => {
                dispatch({ type: COMPLETE });
                dispatch({ type: BACKGROUND_CHECK_UPDATE_OK, data });
                onSuccess(response);
            })
            .catch(error => {
                onError(error);
                dispatch({ type: COMPLETE });
            });
    };
}

export function deleteBackgroundCheck(id, onSuccess = response => null, onError = response => null) {
    return async function(dispatch) {
        dispatch({ type: LOADING });
        call({ path: `/background_check/${id}`, method: methodTypes.DELETE })
            .then(response => {
                dispatch({ type: COMPLETE });
                dispatch({ type: BACKGROUND_CHECK_DELETE_OK, data: response });
                onSuccess(response);
            })
            .catch(error => {
                onError(error);
                dispatch({ type: COMPLETE });
            });
    };
}

export function launchBackgroundCheck(id, onSuccess = response => null, onError = response => null) {
    return async function(dispatch) {
        dispatch({ type: LOADING });
        call({ path: `/background_check/${id}/action/submit`, method: methodTypes.POST })
            .then(response => {
                dispatch({ type: COMPLETE });
                dispatch({ type: BACKGROUND_CHECK_LAUNCH_OK, data: response });
                onSuccess(response);
            })
            .catch(error => {
                onError(error);
                dispatch({ type: COMPLETE });
            });
    };
}



// WEBPACK FOOTER //
// ./src/reducers/backgroundCheck.jsx